module.exports = __webpack_public_path__ + "static/media/img4.7e4e7149.jpg";